import React from "react"

import './registerAnnouncement.scss'

import IconCtg from '../../../components/iconCtg/iconCtg'
import Input from '../../../components/newInput/input'
import Button from '../../../components/newButton/button'
import Loading from '../../../components/loading/loading'
import { FileInput } from '../../../components/fileInput/fileInput'
import AnnoucementCard from '../../../components/annoucementCard/annoucementCard'
import { Mutation, Query } from "react-apollo"
import { Categories, NewHab } from '../../../queries/category'
// import { TOOLS } from '../../../utilits/tools'
import axios from 'axios'
import { GraphQLClient } from 'graphql-request'
import Modal from '../../../components/Modal/modal'
import PhotoZoom from '../../../components/photoZoom/photoZoom'
import Simplert from 'react-simplert'
import { endpoint } from '../../../queries/endpoint'
import { CreateAnuncio, AllAnuncios, UpdateAnuncio } from '../../../queries/anuncios'
import ViewAnnouncement from '../../../components/viewAnnuoncement/viewAnnouncement'
import ErrorBoundary from '../../../components/errorBoundary/errorBoundary'
import { animateScroll as scroll } from 'react-scroll'
import LoadingProgress from '../../../components/loadingprogress/loadingprogress'

export default class RegisterAnnouncement extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            service: [],
            newPro: true,
            createAnun: false,
            value: '',
            showAlert: false,
            typeAlert: '',
            titleAlert: '',
            messageAlert: '',
            customCloseBtnText: 'Fechar',
            customCloseBtnClass: 'buttonnot',
            loading: false,
            editable: false,
            skillsopen: false,
            anuncioId: "",
            description: "",
            price: "",
            active: "",
            skills: "",
            files: "",
            submitOK: false,
            newAnun: true,
            fileName: 'Escolha um arquivo',
            newhab: '',
            show: false,
            openZoom: false,
            toggleChange: false,
            putPrice: true,
            showViewer: false,
            loadingprogress: false,
            now: 0,
            arq: 0,
            arqtotal: 0
        }

        this.anuncios = []
    }

    // currencyInput = (e) => {
    //     if (e.target.value) {
    //         if (!isNaN(e.target.value)) {
    //             this.setState({ price: TOOLS.formatReal(parseInt(TOOLS.onlyNumbers(e.target.value))) })
    //         }
    //     }
    //     // this.setState({ price: e.target.value });
    // };

    openZoom = () => {
        this.setState({ openZoom: !this.state.openZoom })
    };

    openImg = (imgUrl, imgAlt) => {
        this.openZoom();
        this.setState({ zoomUrl: imgUrl, zoomAlt: imgAlt })
    };

    activeToggle = (e) => {
        // console.log(e);
        this.setState({ 
            toggleChange: !this.state.toggleChange, 
            anuncioSelected: e,
            showAlert: false,
        })
    };

    activeViewer = (e) => {
        // console.log(e);
        this.setState({ showViewer: !this.state.showViewer, anuncioSelected: e })
    };

    putPriceAnnouncementClick = () => {
        this.setState({ putPrice: !this.state.putPrice })
    };

    showModal = e => {
        this.setState({
            show: !this.state.show
        })
    }

    // realValue = e => {

    //     let value = ''

    //     if (e.target.value.split("R$ ")[1]) {
    //         // console.log(e.target.value.split("R$ ")[1])
    //         // console.log(!isNaN(parseInt(e.target.value.split("R$ ")[1])))
    //         if (!isNaN(e.target.value.split("R$ ")[1])) {
    //             value = TOOLS.formatReal(TOOLS.onlyNumbers(e.target.value.split("R$ ")[1]), true)
    //             // console.log(value)
    //             this.setState({ price: TOOLS.formatReal(parseInt(e.target.value.split("R$ ")[1])) })
    //         }
    //     }
    //     return (e.target.value = "R$ " + value)
    // }

    createAnuncio = (CreateAnuncio, e) => {
        this.setState({ loading: true, showAlert: false })
        e.preventDefault()

        // console.log(this.state.newAnun)

        let price = "a combinar"
        if (this.state.price !== null && this.state.price !== undefined && this.state.price !== '') {
            if (this.state.price.split(",")[1] === "") {
                price = this.state.price + "00"
            } else {
                price = this.state.price
            }
        }

        if (this.state.newAnun) {

            const cache = JSON.parse(sessionStorage.getItem('OITO'))

            const client = new GraphQLClient(endpoint, {
                headers: {
                    Authorization: `Bearer ${cache.token}`,
                },
            })

            // console.log(data.location)

            client.request(`
            {
                allAnuncios (filter: {
                    skillId: "${this.state.skills}"
                    userId: "${this.userId}"
                  }){
                    id
                  }
         }
            `).then(
                res1 => {
                    // console.log(res)
                    if (res1.allAnuncios && res1.allAnuncios.length > 0) {
                        //nao pode
                        console.log("duplicado")
                        this.setState({
                            skillsopen: null,
                            showAlert: true,
                            typeAlert: 'error',
                            titleAlert: 'Você já possui um anúncio relacionado a essa habilidade.',
                            messageAlert: 'Escolha outra ou edite o anúncio já existente.',
                            onClose: this.closeAlert(),
                            submitOK: false,
                            loading: false,
                        })

                    } else if (res1.allAnuncios && res1.allAnuncios.length <= 0 && this.state.description !== '') {
                        CreateAnuncio({
                            variables: {
                                description: this.state.description,
                                skill: this.state.skills,
                                price: price
                            }
                        }).then(
                            res2 => {
                                // console.log(res.data.createAnuncio.id)
                                if (res2.data.createAnuncio.user.type !== "PROFISSIONAL") {
                                    client.request(`
                                        mutation {
                                        updateUser(
                                            type: PROFISSIONAL,
                                        ){
                                                id
                                                name
                                                birthday
                                                phone
                                                type
                                                email
                                                role
                                                photo
                                                description
                                                phoneverif
                                                address {
                                                    city
                                                    state
                                                    street
                                                    zipcode
                                                    number
                                                    complement
                                                    neighborhood
                                                    country
                                                }                   
                                            }
                                        }
                                                    `).then(
                                        res3 => {
                                            const userAuth = {
                                                token: cache.token,
                                                user: cache.user
                                            }

                                            sessionStorage.setItem('OITO', JSON.stringify(userAuth))
                                        }
                                    )
                                }

                                this.setState({
                                    skillsopen: null,
                                    showAlert: true,
                                    createAnun: false,
                                    newPro: false,
                                    typeAlert: 'success',
                                    titleAlert: 'Cadastro realizado com sucesso!',
                                    // messageAlert: 'Feche este aviso para continuar',
                                    onClose: () => this.closeAlert(res2.data.createAnuncio),
                                    submitOK: false,
                                    loading: false
                                })
                            }
                        ).catch(function (error) {
                            console.log(error);
                        })
                    } else {
                        this.setState({
                            skillsopen: null,
                            showAlert: true,
                            typeAlert: 'error',
                            titleAlert: 'Você não pode deixar a descrição vazia.',
                            messageAlert: 'Por favor digite uma breve descrição do seu serviço. É ela que irá conquistar seus clientes.',
                            onClose: () => this.setState({ showAlert: false }),
                            submitOK: false,
                            loading: false,
                        })
                    }
                }
            ).catch(function (error) {
                console.log(error);
            })
        } else {
            console.log("quantidade de anuncios excedida")
            this.setState({
                skillsopen: null,
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você excedeu a quantidade máxima de anúncios permitidos.',
                messageAlert: 'Caso deseje adicionar uma nova habilidade, desabilite alguma.',
                onClose: this.closeAlert(),
                submitOK: false,
                loading: false,
            })
        }
    }

    // this.statusSkill = (StatusAnuncios, anuncio) => {
    statusSkill = (anuncio) => {
        this.setState({ loading: true, showAlert: false })

        // return console.log(anuncio);
        if (this.state.newAnun || anuncio.active) {
            const cache = JSON.parse(sessionStorage.getItem('OITO'));

            this.activeToggle();

            const client = new GraphQLClient(endpoint, {
                headers: {
                    Authorization: `Bearer ${cache.token}`,
                },
            })

            client.request(`
                    mutation {
                        updateAnuncio (
                            id: "${anuncio.id}",
                            active: ${!anuncio.active},
                        ){
                          id
                          user{
                            id
                            name
                          }
                          description
                          skill{
                            id
                            name
                          }
                          active
                          price
                        }
                    }
                    `).then(
                res => {
                    // console.log(res)
                    this.refetch()
                    this.setState({ newAnun: true, loading: false })
                    // return null
                }
            ).catch(function (error) {
                console.log(error);
            })
            // StatusAnuncios({
            //     variables: {
            //         id: anuncio.id.toString(),
            //         active: !anuncio.active
            //     }
            // }).then(
            //     res => {
            //         // console.log(res)
            //         this.refetch()
            //         this.setState({ newAnun: true, loading: false })
            //         // return null
            //     }
            // ).catch(function (error) {
            //     console.log(error);
            // })
        } else {
            this.setState({
                skillsopen: null,
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você excedeu a quantidade máxima de anúncios permitidos.',
                messageAlert: 'Caso deseje adicionar uma nova habilidade, desabilite alguma.',
                onClose: this.closeAlert(),
                submitOK: false,
                loading: false,
            })
        }

    }

    editSkill = (anuncio) => {
        scroll.scrollToBottom()
        this.setState({
            anuncio,
            anuncioId: anuncio.id,
            description: anuncio.description,
            price: anuncio.price,
            active: anuncio.active,
            skill: anuncio.skill.id,
            files: anuncio.files,
            editable: true
        })
        // this.refetch2()
    }

    editAnuncio = (UpdateAnuncio) => {
        this.setState({ loading: true, showAlert: false })

        let price = "a combinar"
        if (this.state.price !== null && this.state.price !== undefined && this.state.price !== '') {
            if (this.state.price.split(",")[1] === "") {
                price = this.state.price + "00"
            } else {
                price = this.state.price
            }
        }

        // console.log(decimal)

        if (this.state.description !== '') {
            UpdateAnuncio({
                variables: {
                    id: this.state.anuncioId.toString(),
                    description: this.state.description,
                    price: price
                }
            }).then(
                res => {
                    // console.log(res.data)
                    // this.form = {}
                    this.setState({
                        skillsopen: null,
                        showAlert: true,
                        typeAlert: 'success',
                        titleAlert: 'Cadastro atualizado com sucesso!',
                        messageAlert: 'Feche este aviso para continuar',
                        onClose: this.clean(),
                        submitOK: false,
                        loading: false,
                        editable: false
                    })
                    return null
                }
            ).catch(function (error) {
                console.log(error);
            })
        } else {
            this.setState({
                skillsopen: null,
                showAlert: true,
                typeAlert: 'error',
                titleAlert: 'Você não pode deixar a descrição vazia.',
                messageAlert: 'Por favor digite uma breve descrição do seu serviço. É ela que irá conquistar seus clientes.',
                onClose: () => this.setState({ showAlert: false }),
                submitOK: false,
                loading: false,
            })
        }

    }

    closeAlert = (id) => {
        this.setState({ showAlert: false })
        this.refetch()
        // console.log(id)
        if (id !== undefined) this.editSkill(id)
    }

    sendFile = async (e) => {
        // console.log(e.target.files)
        this.setState({ loadingprogress: true })

        if (e.target && e.target.files.length > 0) {
            // let thisanun = ''

            const files = e.target.files

            // console.log(files)

            this.setState({ arqtotal: files.length })

            for (let i = 0; i < files.length; i++) {

                const file = files[i]

                this.setState({ fileName: file.name })

                // console.log("count arq: ", i + 1, "/", files.length)
                this.setState({ arq: (i + 1) })

                const cache = JSON.parse(sessionStorage.getItem('OITO'))

                let data = new FormData();
                data.append('data', file)

                await axios.post('https://api.graph.cool/file/v1/oitoapi', data, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${cache.token}`
                    },
                    onUploadProgress: ProgressEvent => {
                        this.setState({
                            now: parseInt(ProgressEvent.loaded / ProgressEvent.total * 100),
                        })
                        // console.log("arquivo ", ProgressEvent.loaded / ProgressEvent.total * 100)
                    }
                }).then(res => {
                    console.log(res.data.id)

                    // this.form.imgs.push(res.data.id.toString())

                    // console.log(this.form.imgs)

                    const client = new GraphQLClient(endpoint, {
                        headers: {
                            Authorization: `Bearer ${cache.token}`,
                        }
                    })

                    client.request(`
                        mutation{
                            updateFile (
                           id: "${res.data.id}",
                           anunciosId: "${this.state.anuncioId}"
                       ){
                       id
                         name
                         anuncio {
                             id
                    description
                    price
                    active
                    skill {
                        id
                        name
                    }
                    files
                         }
                     }
                     }
                        `).then(
                        res => {
                            console.log(res)
                            if (res.updateFile) this.thisanun = res.updateFile.anuncios
                            // console.log(document.querySelector("#uploadPortfolio").bind(this))
                            // console.log(e.target)
                            // document.getElementById("uploadPortfolio").value = ""
                            // this.refetch()
                            // this.editSkill(res.updateFile.anuncios)
                            // this.setState({ loading: false, fileName: 'Escolha um arquivo' })
                        }
                    ).catch(err => {
                        console.log(err)
                        // this.refetch()
                        // this.setState({ loading: false, fileName: 'Escolha um arquivo' })
                    })
                })
                // console.log("proximo")
            }

            this.refetch()
            // this.editSkill(thisanun)
            // console.log("usando this.", this.thisanun)
            // console.log("sem usar o this.", thisanun)
            this.setState({ loadingprogress: false, fileName: 'Escolha um arquivo' })

        } else {
            this.refetch()
            this.setState({ loadingprogress: false, fileName: 'Escolha um arquivo' })
        }
    }

    clean = () => {
        this.setState({
            value: '',
            showAlert: false,
            loading: false,
            editable: false,
            skillsopen: false,
            anuncioId: "",
            description: "",
            price: "",
            active: "",
            skills: "",
            files: "",
            submitOK: false,
            createAnun: false
        })
        this.refetch()
    }

    deleteFile = (DeleteFile, id) => {
        DeleteFile({
            variables: {
                id: id
            }
        }).then(
            res => {
                console.log(res)
                // this.editSkill(res.deleteFile.anuncios)
            }

        ).catch(err => console.log(err))
        this.refetch()
    }

    NewHab = (NewHab) => {
        NewHab({
            variables: {
                name: this.state.newhab
            }
        }).then(
            res => {
                console.log(res)
                this.setState({
                    show: false,
                    showAlert: true,
                    typeAlert: 'success',
                    titleAlert: 'Sugestão enviada com sucesso!',
                    messageAlert: 'Obrigado por enviar uma sugestão de habilidade, em breve vamos avaliar e adicionar a lista.',
                })
            }
        )
    }

    render() {
        const cache = JSON.parse(sessionStorage.getItem('OITO'))

        if (cache) {
            this.userId = cache.user.id
            this.user = cache.user
            if (cache.user.document === null || cache.user.birthday === null || cache.user.address === null) {
                if (!this.state.showAlert) this.setState({
                    showAlert: true,
                    typeAlert: 'error',
                    titleAlert: 'Você não completou seu cadastro!',
                    messageAlert: 'Para criar um anúncio é necessário que você complete o cadastro.',
                    onClose: () => window.location.href = '/perfil/completarcadastro'
                })
                window.setTimeout(window.location.href = '/perfil/completarcadastro', 2000)
            } else if (!cache.user.phoneverif) {
                if (!this.state.showAlert) this.setState({
                    showAlert: true,
                    typeAlert: 'error',
                    titleAlert: 'Você não verificou o seu celular!',
                    messageAlert: 'Isso é um requisito para que você consiga criar um anúncio.',
                    onClose: () => window.location.href = '/verificartelefone'
                })
                window.setTimeout(window.location.href = '/verificartelefone', 2000)
            }
        } else {
            window.location.href = '/login'
        }

        return (
            <div className={'registerAnnouncement col-xs-12'}  style={{ maxWidth: "980px"}}>
                <div className="row center-xs">
                    <div className={'title col-xs-12'} >
                        <h1>Meus Anúncios</h1>
                        {/* <span>/TEXTO EXPLICACAO/</span> */}
                    </div>
                    <div className="col-xs-12 end-xs" style={{ marginBottom: '15px' }}>{!this.state.newPro && !this.state.createAnun ? <Button onClick={() => { this.setState({ createAnun: true }); scroll.scrollToBottom() }} name={'criar anúncio'} />
                        : null}</div>

                    <div className="row center-xs listannuns">
                        <Query query={AllAnuncios} fetchPolicy={"no-cache"} variables={{ id: this.userId }}>
                            {res => {
                                if (res.loading) return <Loading />
                                if (res.error) return console.log(res.error)
                                // console.log(res.data.allAnuncioses)

                                this.refetch = res.refetch
                                
                                if (res.data) {

                                    const anuncios = res.data.allAnuncios

                                    if (this.state.newPro === true) {
                                        if (anuncios.length > 0) {
                                            this.setState({ newPro: false })
                                        }
                                    }

                                    if (anuncios && anuncios.length) {

                                        let sum = 0
                                        res.data.allAnuncioses.map(a => a.active ? sum++ : null)
                                        if (sum >= 3 && this.state.newAnun) {
                                            this.setState({ newAnun: false })
                                        }

                                        if (this.state.anuncioId !== '' && this.state.editable) {
                                            anuncios.map((anuncio) => (
                                                this.state.anuncioId === anuncio.id ?
                                                    this.state.files !== anuncio.files ?
                                                        this.setState({
                                                            files: anuncio.files,
                                                        }) : null : null))
                                        }

                                        // return <div id='selected'>
                                        return !this.state.createAnun && !this.state.newPro ? anuncios.map((anuncio, i) => (
                                            <ErrorBoundary key={i}><AnnoucementCard title={anuncio.skills.name} desc={anuncio.description} price={anuncio.price} annouActive={anuncio.active} edit={() => this.editSkill(anuncio)} del={() => this.activeToggle(anuncio)} view={() => this.activeViewer(anuncio)} /></ErrorBoundary>
                                        )) : null
                                        // </div>
                                    } else {
                                        return null
                                    }
                                } else {
                                    return null
                                }
                            }}
                        </Query>
                    </div>
                </div>

                {this.state.loadingprogress ? <LoadingProgress now={this.state.now} arq={this.state.arq} arqtotal={this.state.arqtotal} /> : null}

                {/* {this.state.toggleChange ? */}
                <Modal onClose={this.activeToggle} show={this.state.toggleChange} title={'Situação do anúncio'}>
                    <p>Deseja {this.state.anuncioSelected ? this.state.anuncioSelected.active ? "desativar" : "ativar" : null} seu anúncio nesse momento?</p>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={() => this.statusSkill(this.state.anuncioSelected)} name={this.state.anuncioSelected ? this.state.anuncioSelected.active ? "Desativar o anúncio" : "Ativar o anúncio" : null} />
                        <button className="buttoncancel" onClick={this.activeToggle}>Cancelar</button>
                    </div>
                </Modal>
                {/* // : null} */}

                <Modal onClose={this.activeViewer} show={this.state.showViewer} title={'Prévia do anúncio'}>
                    <ErrorBoundary><ViewAnnouncement player={this.user} anuncio={this.state.anuncioSelected} /></ErrorBoundary>
                </Modal>

                <Modal show={this.state.show} onClose={this.showModal} title={'Sugestão de habilidade'}>
                    <div>
                        <p>Não encontrou sua habilidade? Nos diga qual é que em breve iremos adicionar.</p>
                        <form id="formpropose">
                            <div className="col-12">
                                <Input name="newhab" placeholder="Digita a habilidade que procura" type="text" onInput={(e) => this.setState({ newhab: e.target.value })} />
                            </div>
                            <div className="col-12">
                                <Mutation mutation={NewHab}>
                                    {(NewHab, { loading, error }) => {
                                        if (loading) return <Loading />
                                        if (error) return console.log(NewHab.error)
                                        return <Button
                                            name='Enviar'
                                            type='submit'
                                            disabled={this.state.newhab ? false : true}
                                            onClick={() => this.NewHab(NewHab)}
                                        />
                                    }}
                                </Mutation>
                            </div>
                        </form>
                    </div>
                </Modal>

                <Simplert
                    showSimplert={this.state.showAlert}
                    type={this.state.typeAlert}
                    title={this.state.titleAlert}
                    message={this.state.messageAlert}
                    customCloseBtnText={this.state.customCloseBtnText}
                    customCloseBtnClass={this.state.customCloseBtnClass}
                    onClose={this.state.onClose}
                />

                {this.state.openZoom ? <ErrorBoundary><PhotoZoom onClose={this.openZoom} imgUrl={this.state.zoomUrl} imgAlt={this.state.zoomAlt} /></ErrorBoundary> : null}

                {this.state.createAnun || this.state.newPro ?
                    <div className="row center-xs">
                        <div className="col-xs-12 titlecat end-xs">
                            <h3>Selecione uma categoria</h3>
                            {/*<button onClick={() => this.clean()}>voltar</button>*/}
                            {this.state.createAnun ? <Button onClick={() => this.clean()} name="Fechar" /> : null}
                        </div>

                        <div className={'col-xs-12 row center-xs catg'}>
                            <Query query={Categories}>
                                {result => {
                                    if (result.loading) return <Loading />
                                    if (result.error) return <p>{result.error.message}</p>
                                    // console.log(result.data.allCategories)
                                    return <ErrorBoundary>
                                        {result.data.allCategories.length ?
                                            result.data.allCategories.map((p, i) =>
                                                <ErrorBoundary><IconCtg key={i} icon={p.file} label={true} name={p.name} onClick={() => { scroll.scrollToBottom(); this.setState({ filtered: true, service: p.skills }) }} /></ErrorBoundary>
                                            ) : null}
                                    </ErrorBoundary>
                                }}
                            </Query>
                        </div>

                        {/* APARECER QND CATEGORIA É SELECIONADA*/}
                        {this.state.service.length > 0 ?
                            <div className={'subCatg col-xs-12'} style={{ marginTop: 30 }}>
                                <select name="categ" id="" onChange={(e) => { scroll.scrollToBottom(); this.setState({ skills: e.target.value }) }}>
                                    <option value="">Escolha uma habilidade</option>
                                    {this.state.service.map((hab, i) => (
                                        <option value={hab.id} key={i} >{hab.name}</option>
                                    ))}
                                </select>
                                <p onClick={this.showModal} className='linknew'>Não encontrou sua habilidade?</p>
                            </div>
                            : null}

                        {this.state.skills ? <div className="row center-xs">
                            <div className="col-xs-12">
                                <h3>Informações do anúncio</h3>
                            </div>
                            <div className="col-xs-12 start-xs precifing">
                                <div><span>Como deseja negociar seu serviço?</span></div>
                                <div>
                                    <button style={{ background: 'none', border: 'none' }} onClick={this.putPriceAnnouncementClick}>
                                        <svg style={{ width: '24px', height: '24px', color: '#707070' }} viewBox="0 0 24 24">
                                            {this.state.putPrice ? <path fill="#ff8000" d="M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M17,15A3,3 0 0,1 14,12A3,3 0 0,1 17,9A3,3 0 0,1 20,12A3,3 0 0,1 17,15Z" />
                                                : <path fill="#707070" d="M17,7H7A5,5 0 0,0 2,12A5,5 0 0,0 7,17H17A5,5 0 0,0 22,12A5,5 0 0,0 17,7M7,15A3,3 0 0,1 4,12A3,3 0 0,1 7,9A3,3 0 0,1 10,12A3,3 0 0,1 7,15Z" />}
                                        </svg>
                                    </button>
                                    <span>{this.state.putPrice ? <b>Precificar</b> : <b>Preço a combinar</b>}</span>
                                </div>
                            </div>
                            <form className="col-xs-12">
                                <div className={'desc'}>
                                    <Input placeholder={'Descreva brevemente o que você faz e dê informações claras, verdadeiras e sucintas.'} name={'description'} maxlength={64} onInput={(e) => this.setState({ description: e.target.value })} required={true} />
                                    {this.state.putPrice ?
                                        <Input onChange={(e) => this.setState({ price: e.target.value.split("R$ ")[1] })} placeholder={'Insira a sua média de preço por unidade ou tempo de serviço.'} name={'price'} money={true} />
                                        // <Input placeholder={'Insira a sua média de preço por unidade ou tempo de serviço.'} name={'price'} value={this.state.price} onInput={(e) => this.realValue(e)} /> 
                                        : null}
                                </div>

                                <div style={{ textAlign: 'center' }}>
                                    <Mutation mutation={CreateAnuncio}>
                                        {(CreateAnuncio, { loading, error }) => {
                                            if (loading) return <Loading />
                                            if (error) console.log(error)
                                            return <Button name={'Salvar'} disabled={this.state.description ? false : true} onClick={(e) => this.createAnuncio(CreateAnuncio, e)} />
                                        }}
                                    </Mutation>

                                </div>
                            </form>
                        </div> : null}
                    </div>
                    : this.state.editable ? <div className="form-container row center-xs">
                        
                        <form id="myform" className="col-xs-12">
                            <div className="end-xs fechando">
                                <Button onClick={() => this.clean()} name="Fechar" />
                            </div>
                        
                            <h3>Editar anúncio de serviço</h3>
                            <div className="row center-xs">
                                {/* <div style={{marginBottom: '15px'}}>Esse anúncio está ativo? {this.state.active}</div> -------------------COLOCAR A PORRA DO TOOGLE */}

                                <div className="col-xs-12">
                                    <i className="fas fa-arrow-left back" onClick={() => this.clean()}></i>
                                </div>
                                <div className="col-xs-12">
                                    <Input onChange={(e) => this.setState({ description: e.target.value })} defaultValue={this.state.description} name="desc2" label="Descrição" placeholder="Insira uma breve descrição das atividades que realiza." type="text" maxlength={64} />
                                </div>
                                <div className="col-xs-12">
                                    {/*<Input onChange={this.currencyInput} defaultValue={`R$${this.state.price}`} name="price" label="Valor" placeholder="Insira o valor que você cobra para realizar o seu serviço." type="text"/>*/}
                                    <Input onChange={(e) => this.setState({ price: e.target.value.split("R$ ")[1] })} defaultValue={this.state.price} money={true} name="price" label="Valor" placeholder="Insira o valor que você cobra para realizar o seu serviço." />
                                    {/* <Input onChange={(e) => this.realValue(e)} defaultValue={this.state.price} name="price" label="Valor" placeholder="Insira o valor que você cobra para realizar o seu serviço." type="text" /> */}
                                </div>

                                <div className="col-xs-12" style={{ marginBottom: '15px', textAlign: "left" }}>
                                    <h3>Adicionar Foto</h3>
                                    {/*<input type="file" onChange={(e) => this.sendFile(e)} accept="image/*" id="uploadPortfolio" />*/}
                                    <FileInput name={'fileInputs'} onchange={(e) => this.sendFile(e)} accept="image/*" id="uploadPortfolio" filename={this.state.fileName} />
                                    {this.state.loading ? <Loading /> : null}
                                </div>

                                <div className="col-xs-12 photo-register-announcement">
                                    <h3>Fotos</h3>
                                    <div className="row center-xs">
                                        {this.state.files.length > 0 ? this.state.files.map((file, i) => {
                                            return <div key={i}>
                                                <img src={file.url} alt={file.name} onClick={() => this.openImg(file.url, file.name)} style={{ width: 150, height: 150 }} />
                                                {/* <Mutation mutation={DeleteFile}>
                                                    {(DeleteFile, { loading, error }) => {
                                                        if (loading) return <Loading />
                                                        if (error) console.log(error.message)
                                                        // this.deleteId = file.id
                                                        return <Button type="submit" onClick={() => this.deleteFile(DeleteFile, file.id)} name="Delete"/>
                                                    }}
                                                </Mutation> */}
                                            </div>
                                        }) : null}
                                    </div>
                                </div>

                            </div>
                            <div className="register-two-buttons col-xs-12">
                                <Mutation mutation={UpdateAnuncio}>
                                    {(UpdateAnuncio, { loading, error }) => {
                                        if (loading) return <Loading />
                                        if (error) console.log(error.message)
                                        return <Button type="submit" onClick={() => this.editAnuncio(UpdateAnuncio)} className={!this.state.description ? 'disable' : null} name={"Salvar"} />
                                    }}
                                </Mutation>
                            </div>
                        </form>
                    </div> : null}
            </div>
        )
    }
}
